import { ref } from 'vue'
import { defineStore } from 'pinia'
import { dashboardApi } from '../api/dashboard.api'
import type { MetricDeliveryStatusRequest } from '../api/dashboard.requests'
import type {
  ActionSetting,
  DeliveryStatusSetting,
  MetricAction,
  MetricDeliveryStatus,
} from '../models/dashboard.model'
import type { Filter } from '@/modules/filter/models/filter.model'

export const useDashboardStore = defineStore('dashboard', () => {
  const actions = ref<MetricAction[]>([])
  const deliveryStatus = ref<{ [id: number]: MetricDeliveryStatus }>()
  const deliveryStatusSettings = ref<DeliveryStatusSetting[]>([])
  const actionSettings = ref<ActionSetting[]>([])
  const total = ref<number>(0)

  const loadSettings = async () => {
    const response = await dashboardApi.getSettings()

    if (!response.error && response.data) {
      deliveryStatusSettings.value = response.data.deliveryStatusSettings
      actionSettings.value = response.data.actionSettings
    }
  }

  const loadActions = async (body: Filter): Promise<void> => {
    const response = await dashboardApi.getActions(body)

    if (response.error || !response.data) return

    actions.value = response.data
  }

  const loadDeliveryStatus = async (body: MetricDeliveryStatusRequest): Promise<void> => {
    const response = await dashboardApi.getDeliveryStatus(body)

    if (response.error || !response.data) return

    deliveryStatus.value = response.data.status
    total.value = response.data.total
  }

  return {
    total,
    actions,
    actionSettings,
    deliveryStatus,
    deliveryStatusSettings,
    loadSettings,
    loadActions,
    loadDeliveryStatus,
  }
})
